<template>
  <div
    class="code-container clickable"
    title="Copy Code"
  >
    <a      
      v-clipboard="{ copyText: code }"
      v-tooltip.right="'Copy Code'"
      class="copy-code btn btn-function"
      tooltip-placement="right"
      aria-hidden="true"
      @click="showCopiedNotification()"
    >
      <i
        class="typcn typcn-tabs-outline"
        :class="{'text-success': codeCopied}"
      />
    </a>
    
    <pre
      v-clipboard="{ copyText: code }"
      class="p-t-0 p-b-0 m-b-0"
      :class="preClass"
      @click="handleCodeContainerClick()"
    >
        <slot />
      </pre>
  </div>
</template>

<script>
import { utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default {
  name: 'CodeContainer',
  props:{
    code: {
      type: String,
      default: ''
    },
    successTranslation: {
      type: String,
      default: 'Copied'
    },
    preClass: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      codeCopied: false
    };
  },
  methods: {
    handleCodeContainerClick() {
      this.codeCopied = !this.codeCopied;
      this.showCopiedNotification();
      setTimeout(() => {
        this.codeCopied = !this.codeCopied;
      }, 100);
    },

    showCopiedNotification() {
      utilities.showToasterWithOptions(
        {
          type:'success', 
          body: this.$i18n.t(this.successTranslation),
          timeout : 3000
        });
    }
  }
};
</script>

<style scoped>
.changelogs.empty-changelog {
  min-height: 0;
}
</style>